export const LOAD_TABLE = 'LOAD_TABLE'
export const RESET_TABLE = 'RESET_TABLE'
export const SAVE_TABLE_INFO = 'SAVE_TABLE_INFO'

